import { VERTICAL_KEYS } from '../vertical.js';
import type { VerticalLandingContent } from './types.js';

// =============================================================================
// Proteção Veicular landing content. Tom: confiança + clareza + atendimento
// local, com pegada cooperativa (não jurídico opaco). Inspirado no site da
// Risco Zero (primeiro parceiro PV), mas trabalhado pra ser mais direto e
// menos "conforme regulamento" repetido.
//
// O FormConfig e o qualifier estão configurados separadamente; este arquivo
// é só a copy da landing. Quando outro parceiro PV entrar, o broker dele
// herda esse content até customizar via broker.pageContent.
// =============================================================================

export const protecaoVeicularLandingContent: VerticalLandingContent = {
  verticalKey: VERTICAL_KEYS.PROTECAO_VEICULAR,

  // Navy + gold da Risco Zero. Combina com a percepção "tradição/seguro
  // financeiro" comum em proteção veicular e contrasta com o tom mais
  // frio do MCMV. Brokers PV futuros podem customizar via pageContent.theme
  // sem refletir aqui.
  defaultTheme: {
    primaryColor: '#03003B',
    accentColor: '#D5A13C',
  },

  brokerSubtitle: 'Proteção Veicular',
  brokerHeaderCta: 'Solicitar cotação',
  brokerCardLabel: 'Atendimento',
  brokerCardCta: 'Receber minha cotação',

  heroBadge: 'Proteção Veicular · cotação no WhatsApp',
  heroHeadlineDefault: 'Proteção veicular pra quem depende do carro todos os dias',
  heroSubheadlineDefault:
    'Atendimento humano antes da adesão, cobertura nacional e cotação rápida pelo WhatsApp. Você entende o plano direitinho antes de assinar.',
  heroPrimaryCta: 'Solicitar minha cotação',
  heroSecondaryCta: 'Saber mais',
  trustBadges: ['Sem consulta ao SPC', 'Cobertura nacional', 'Atendimento 24h'],

  howItWorksTitle: 'Como funciona',
  howItWorksSubtitle: 'Três passos pra ter seu veículo protegido.',
  howItWorksSteps: [
    {
      title: 'Preencha seus dados',
      body: 'Perguntas rápidas sobre o veículo e como você usa. A placa ajuda a gerar uma cotação mais precisa.',
    },
    {
      title: 'Receba sua cotação',
      body: 'Mostramos o plano que mais combina com seu perfil, com as condições explicadas direitinho — sem letra miúda.',
    },
    {
      title: 'Fale com o consultor',
      body: 'Tira as dúvidas no WhatsApp, finaliza o cadastro e seu veículo entra em proteção.',
    },
  ],

  aboutTitle: 'Quem vai te atender',

  // Sem seção de "planos" pra Risco Zero: a landing fica sem a grid de
  // listings (a PropertiesSection só renderiza quando há properties no
  // broker). Mantemos as labels caso outro parceiro PV decida publicar.
  listingsTitle: 'Coberturas',
  listingsSubtitle: 'Proteção pra quem depende do veículo todos os dias.',

  faqTitle: 'Perguntas frequentes',
  faqSubtitle: 'Tire suas dúvidas antes de solicitar a cotação.',
  faqItems: [
    {
      q: 'Proteção veicular é a mesma coisa que seguro?',
      a: 'Não. Os dois protegem o veículo, mas funcionam diferente. A proteção veicular é um modelo associativo: o grupo de associados divide os custos das ocorrências. Por isso costuma ter mensalidade mais baixa que o seguro tradicional e não exige análise de crédito. O consultor explica as condições direitinho antes da contratação.',
    },
    {
      q: 'Preciso de análise de crédito ou consulta ao SPC?',
      a: 'Não. Não consultamos SPC/Serasa nem exigimos análise de perfil. Basta o documento do veículo e o seu CPF pra cadastro.',
    },
    {
      q: 'A assistência 24h funciona em todo o Brasil?',
      a: 'Sim. A central atende 24 horas, todos os dias do ano, em qualquer ponto do território nacional. Em caso de sinistro, indica oficina parceira ou reembolsa conforme o plano contratado.',
    },
    {
      q: 'E se meu veículo for mais antigo?',
      a: 'Aceitamos veículos com até 25 anos de uso na maioria dos planos — diferente de seguradoras tradicionais, que costumam recusar carros acima de 15 anos.',
    },
    {
      q: 'A cotação tem custo?',
      a: 'Não. Você só paga se decidir contratar. A cotação é feita pelo formulário ou direto no WhatsApp, sem compromisso.',
    },
    {
      q: 'Por que preciso informar a placa do veículo?',
      a: 'A placa ajuda a identificar marca, modelo e ano do veículo automaticamente, o que torna a cotação mais precisa.',
    },
    {
      q: 'Como falar com a equipe pelo WhatsApp?',
      a: 'Você pode iniciar a conversa direto pelo botão "Solicitar cotação" no topo da página. Ele abre o WhatsApp com uma mensagem pronta, é só enviar.',
    },
  ],

  finalCtaTitle: 'Pronto pra proteger seu veículo?',
  finalCtaSubtitle: 'Cotação pelo WhatsApp em 2 minutos, sem compromisso.',
  finalCtaButton: 'Receber minha cotação',

  footerLabel: 'Sistema de cotação de proteção veicular por NexoFácil',

  listingBadge: 'Plano disponível',
  listingCta: 'Quero saber mais',
  listingCtaHint: 'Cotação rápida no WhatsApp',
  listingNoPriceHint: 'Faça a cotação pra receber as condições exatas do seu plano.',
  backToListings: 'Voltar',
};
